import React, { useState, useEffect } from "react";
import "../styles/PurchaseHistory.css";
import MyPageSidebar from "./MyPageSidebar";
import PurchaseHistorySection from "./PurchaseHistorySection";

const PurchaseHistory = () => {
    const [purchaseHistory, setPurchaseHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPurchaseHistory = async () => {
            try {
                const response = await fetch("/api/purchase-list");
                if (!response.ok) {
                    throw new Error("구매내역을 불러올 수 없습니다.");
                }
                const data = await response.json();

                if (data.purchaseData === "noData") {
                    setPurchaseHistory([]); // 구매 내역 없음 처리
                } else {
                    setPurchaseHistory(data.purchaseData);
                }
            } catch (error) {
                console.error("구매내역 조회 실패:", error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPurchaseHistory();
    }, []);

    if (loading) return <p>로딩 중...</p>;
    if (error) return <p className="error-message">❌ {error}</p>;

    return (
        <div className="mypage-layout">
            <MyPageSidebar />
            <div className="mypage-content-list-container">
                {/*<h2 className="mypage-title">구매 내역</h2>*/}
                <PurchaseHistorySection purchases={purchaseHistory} />
            </div>
        </div>
    );
};

export default PurchaseHistory;
